export default __webpack_public_path__ + "images/wbtcIcon_c483b5.svg";